const STORAGE_KEY = 'clicklogos_guest_generation';
const SESSION_KEY = 'clicklogos_session_id';

interface GuestGenerationData {
  generated: boolean;
  logoUrl?: string;
  brandData?: Record<string, unknown>;
  timestamp: number;
}

export const useGuestGeneration = () => {
  const hasGeneratedPreview = (): boolean => {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      if (!data) return false;
      
      const parsed: GuestGenerationData = JSON.parse(data);
      
      // Check if generation is less than 24 hours old
      const twentyFourHours = 24 * 60 * 60 * 1000;
      if (Date.now() - parsed.timestamp > twentyFourHours) {
        localStorage.removeItem(STORAGE_KEY);
        return false;
      }
      
      return parsed.generated;
    } catch {
      return false;
    }
  };

  const markGenerated = (logoUrl: string, brandData?: Record<string, unknown>) => {
    const data: GuestGenerationData = {
      generated: true,
      logoUrl,
      brandData,
      timestamp: Date.now()
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  };

  const getLastGeneration = (): GuestGenerationData | null => {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      if (!data) return null;
      return JSON.parse(data);
    } catch {
      return null;
    }
  };

  const getSessionId = (): string => {
    let sessionId = sessionStorage.getItem(SESSION_KEY);
    if (!sessionId) {
      sessionId = crypto.randomUUID();
      sessionStorage.setItem(SESSION_KEY, sessionId);
    }
    return sessionId;
  };

  const clearGeneration = () => {
    localStorage.removeItem(STORAGE_KEY);
  };

  return { 
    hasGeneratedPreview, 
    markGenerated, 
    getLastGeneration,
    getSessionId,
    clearGeneration
  };
};
